export enum LogLevel {
  Debug,
  Info,
  Warn,
  Error
}